import { Container, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CenteredContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  justify-content: center;
`;

export const Column = styled(Stack)`
  justify-content: center;
  align-items: center;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    flex-grow: 1;
    align-items: center;
    min-height: 100vh;
  }
`;
